import { c as _c } from "react/compiler-runtime";
import { type ReactNode } from 'react';
import Image from 'next/image';
import { mergeClasses } from '@/utils/style';
import { Text, Headline } from '@/components/typography';
export interface AdvantageBoxProps {
  image: string;
  title: string;
  text: string | ReactNode;
}
export function AdvantageBox(props) {
  const $ = _c(14);
  const {
    image,
    text,
    title
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = mergeClasses("h-full max-w-full rounded-2xl bg-white p-4 pb-8", "md:max-w-[368px]");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== image || $[2] !== title) {
    t1 = <div className="relative block aspect-[2/1]"><Image src={image} alt={title} className="h-full w-full rounded-lg object-cover" width={336} height={168} /></div>;
    $[1] = image;
    $[2] = title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== title) {
    t2 = <Headline as="h4" variant="h6">{title}</Headline>;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== text) {
    t3 = <Text as="div" variant="p3" className="mt-2 text-gray-700">{text}</Text>;
    $[6] = text;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="mt-6 block px-2 lg:mt-7">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t4) {
    t5 = <div className={t0}>{t1}{t4}</div>;
    $[11] = t1;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}